import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { ISampleBlend } from '../../models/ISampleBlend';
import { IBlendTotalQuota } from '../../models/IBlendTotalQuota';
import { ISampleBlendMember } from '../../models/ISampleBlendMember';
import { ISupplier, ISupplierMap } from '../../models/ISupplier';
import { Item } from '../../models/IItem';
import { FezaDataService } from '../../services/fezadata.service';
import { Utils } from '../../Utils'

@Component({
  selector: 'blend-viewer',
  templateUrl: './blend-viewer.component.html',
  styleUrls: ['./blend-viewer.component.css']
})
export class BlendViewerComponent implements OnInit {
  @Input() blend: ISampleBlend;
  @Input() fezaId: string;
  @Input() hideCosts: boolean;
  @Input() editMode: boolean;
  @Input() allowEdit: boolean;
  @Input() suppliers: ISupplier[];
  @Output() setEditMode: EventEmitter<boolean> = new EventEmitter();
  @Output() onSave: EventEmitter<IBlendTotalQuota> = new EventEmitter();

  editBlend: IBlendTotalQuota;
  totalPercent: number = 0;
  newItem: ISupplier = { supplierId: null, supplierName: null } as ISupplier;
  saving: boolean;
  
  constructor(private fezaDataService: FezaDataService) {
      this.editBlend = { buffer: 0, members: [] } as IBlendTotalQuota;
  }

  ngOnInit() {
    this.resetEditToCurrentBlend();
  }

  resetEditToCurrentBlend() {
    this.editBlend = { buffer: (this.blend.blendTotalQuota.buffer || 0), members: [], } as IBlendTotalQuota;
    for (let m of (this.blend.blendTotalQuota.members || [])) {
      this.editBlend.members.push({ id: m.id, name: m.name, blendPercent: m.blendPercent } as ISampleBlendMember);
    }
    this.onUpdateTotal();
  }

  onUpdateTotal() {
    this.totalPercent = +this.editBlend.buffer;
    for (let m of this.editBlend.members) {
      this.totalPercent += (+m.blendPercent);
    }
  }

  remaingPercent() {
    return (100 - this.totalPercent > 0) ? (100 - this.totalPercent) : 0;
  }

  onEdit() {
    this.setEditMode.emit(true);
    this.resetEditToCurrentBlend();
  }

  onCancel() {
    this.setEditMode.emit(false);
    this.resetEditToCurrentBlend();
  }

  onSaveButton() {
    this.saving = true;
    var newBlend = {
      blendTotalQuota: this.editBlend,
      blendTotalQuotaSummary: { fieldDuration: this.blend.blendTotalQuotaSummary.fieldDuration }
    } as ISampleBlend;

    this.fezaDataService.SaveBlend(newBlend, this.fezaId, true)
      .subscribe(res =>
      {
        this.saving = false;
        this.setEditMode.emit(false);
        this.onSave.emit();
      }, err => {
        this.saving = false;
      });
  }

  onChangeSupplier(blendMember: ISampleBlendMember, index: number) {
    if (blendMember.id === null || this.editBlend.members.find(x => x.id === blendMember.id /*already exits...*/) !== undefined)
      this.editBlend.members.splice(index, 1);
    this.onUpdateTotal();
  }

  onAddNewSupplier(supplierId: number) {
    var existingRowForSupplier = this.editBlend.members.findIndex(x => x.id === supplierId);
    if (existingRowForSupplier !== -1)
      this.editBlend.members.splice(existingRowForSupplier, 1);
    var supplier = this.suppliers.find(x => x.supplierId == supplierId);
    this.editBlend.members.push({ id: supplier.supplierId, name: supplier.supplierName, blendPercent: this.remaingPercent() } as ISampleBlendMember);
    //ng-select doesn't support "unsetting" the value in a straight forward way
    setTimeout(() => this.newItem = { supplierId: null, supplierName:null } as ISupplier);
  }

    setupFeeLabel(member: ISampleBlendMember) {
        var supplier = (this.suppliers || []).find(x => x.supplierId == member.id && member.memberType == "Supplier");
        var fee = Utils.toTwo(member.supplierSetupFee || 0);
        var formula = null;
        var level = "";
        if (supplier) {
            formula = supplier.supplierFees.surveyAPISetupFee != "" ? supplier.supplierFees.surveyAPISetupFee : null;
            level = supplier.supplierFees.setupFeeLevel != "" ? `(${supplier.supplierFees.setupFeeLevel})` : null;
        }
        return `${formula || fee} ${member.supplierCurrency} ${level}`;
    }

    minFeeLabel(member: ISampleBlendMember) {
        var supplier = (this.suppliers || []).find(x => x.supplierId == member.id && member.memberType == "Supplier");
        var fee = Utils.toTwo(member.minimumFee || 0);
        var formula = null;
        var level = "";
        if (supplier) {
            formula = supplier.supplierFees.surveyAPIMinFee != "" ? supplier.supplierFees.surveyAPIMinFee : null;
            level = supplier.supplierFees.minFeeLevel != "" ? `(${supplier.supplierFees.minFeeLevel})` : null;
        }
        return `${formula || fee} ${member.supplierCurrency} ${level}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/blend-viewer/blend-viewer.component.ts